import { useCallback, useEffect, useState } from 'react';
import Select from 'react-select';

import { searchUser } from '~modules/user/api';
import { UserDto } from '~modules/user/model';
import { useDebounce } from '~shared/hooks';

// import { SelectItem } from '~shared/ui/select/select-item';

export function UserSearchSelect({
	defaultValue,
	onSelectUser,
}: {
	defaultValue: UserDto | null;
	onSelectUser: (user: UserDto | null) => void;
}) {
	const [inputValue, setInputValue] = useState('');
	const [options, setOptions] = useState<UserDto[]>([]);
	const [isLoading, setIsLoading] = useState(false);

	const debouncedSearchTerm = useDebounce(inputValue, 500);

	const searchUsers = useCallback(async (search: string) => {
		if (!search.trim()) {
			setOptions([]);
			return;
		}

		setIsLoading(true);
		try {
			const data = await searchUser(search);

			setOptions(data);
		} catch (error) {
			console.error('Search failed:', error);
			setOptions([]);
		} finally {
			setIsLoading(false);
		}
	}, []);

	useEffect(() => {
		if (debouncedSearchTerm) {
			searchUsers(debouncedSearchTerm);
		} else {
			setOptions([]);
		}
	}, [debouncedSearchTerm, searchUsers]);

	return (
		<div className="user-search-select">
			<Select<UserDto>
				inputId="user-select"
				className="react-select-container"
				options={options}
				defaultValue={defaultValue}
				inputValue={inputValue}
				onInputChange={setInputValue}
				onChange={user => onSelectUser(user)}
				isLoading={isLoading}
				isClearable
				placeholder="Начните вводить имя пользователя..."
				noOptionsMessage={() => (inputValue ? 'Ничего не найдено' : 'Введите имя для поиска')}
				getOptionLabel={user => user.name}
				getOptionValue={user => user.preferred_username}
				loadingMessage={() => 'Поиск...'}
			/>
		</div>
	);
}
